/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ budget: NonNullable<unknown> }} Sub_Quotas_Over_Budget_Raise_ButtonInputs */



/**
* | output |
* | --- |
* | "Raise budget to {budget}" |
*
* @param {Sub_Quotas_Over_Budget_Raise_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_raise_button = /** @type {((inputs: Sub_Quotas_Over_Budget_Raise_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_Raise_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Budget auf ${i?.budget} erhöhen`)
	return /** @type {LocalizedString} */ (`Raise budget to ${i?.budget}`)
});